/**
 * @generated SignedSource<<2fd75a3686085a9e4c79c2abebce0e07>>
 * @relayHash c5cc378e0d767131cb5851e5f3e027d6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c5cc378e0d767131cb5851e5f3e027d6

import { ConcreteRequest } from 'relay-runtime';
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type preventionProgramsSectionChQuery$variables = {
  search: string;
};
export type preventionProgramsSectionChQuery$data = {
  readonly preventionPrograms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly name: {
          readonly de: string;
          readonly en: string;
          readonly fr: string;
          readonly it: string;
        };
        readonly specialty: ServiceSpecialty;
      };
    }> | null;
  } | null;
};
export type preventionProgramsSectionChQuery = {
  response: preventionProgramsSectionChQuery$data;
  variables: preventionProgramsSectionChQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": "preventionPrograms",
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "ch_PreventionProgramSummaryConnection",
    "kind": "LinkedField",
    "name": "ch_preventionPrograms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_PreventionProgramSummaryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PreventionProgramSummary",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "en",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "de",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fr",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "it",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialty",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "preventionProgramsSectionChQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "preventionProgramsSectionChQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "c5cc378e0d767131cb5851e5f3e027d6",
    "metadata": {},
    "name": "preventionProgramsSectionChQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e4f20063ec6987a8f0413e471edfb494";

export default node;
